export enum TrainingTypologyEnum {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
}

export const getTrainingTypologyLabel = (typology: TrainingTypologyEnum): string => {
  switch (typology) {
    case TrainingTypologyEnum.INTERNAL:
      return "Interna";
    case TrainingTypologyEnum.EXTERNAL:
      return "Externa";
  }
};

export const getTrainingTypologyOptions = (): { value: TrainingTypologyEnum; label: string }[] => {
  const keys = Object.keys(TrainingTypologyEnum).filter(
    (key: string) => typeof TrainingTypologyEnum[key as keyof typeof TrainingTypologyEnum] === "string",
  );
  return keys.map((val) => {
    const value = TrainingTypologyEnum[val as keyof typeof TrainingTypologyEnum];
    return { label: getTrainingTypologyLabel(value), value };
  });
};
